import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const { containerized, margin } = attributes;
  const ALLOWED_BLOCKS = ['app/accordion-item'];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`${margin}`}>
        <div className={`${containerized ? 'Container' : ''}`}>
          <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
        </div>
      </section>
    </>
  );
};
